import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCartItems } from "../../actions/cartAction";
import BreadCrumb from "../../components/Breadcrumb";
import NewPrescriptionList from "./NewPrescriptionList";
import PractitionerPrescriptionHistory from "./PractitionerPrescriptionHistory";
import PrescriptionHistory from "./PresciptionHistory";
import RefillRequest from "./RefillRequest";
const Prescriptions = () => {
  const role = useSelector((state) => state.role.role);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCartItems(role.val));
  }, []);
  return (
    <div className="patients-page">
      <BreadCrumb pageName="Prescriptions" />
      <div className="row">
        <div className="col-sm-12">
          <h3 className="page-title">Prescriptions</h3>
          <p className="page-desc">
            View the status of an order and the prescription history.
          </p>
          <div className="m-1">
            {role && role.val === 3 ? (
              <>
                <NewPrescriptionList />
                <PrescriptionHistory />
              </>
            ) : (
              <>
                <RefillRequest />
                <PractitionerPrescriptionHistory />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Prescriptions;
